import { useChuckClientContext, useAPI } from '@gopeerproject/chuck'
import { useMutation } from 'react-query'
import { useClassroomState } from './useClassroom'

export const useClassroomActionOpen = (options) => {
  const { id } = useClassroomState()
  const { post } = useAPI()
  const { client } = useChuckClientContext()

  return useMutation(
    () => post({ url: `/classrooms/${id}/open` }).then((res) => res.data),
    {
      onError: (err) => {
        client.captureException(err)
      },
      ...options
    }
  )
}
